/**
 * Created by filatov on 27.10.2015.
 */
import $ from 'jquery'
import DropdownDialog from '../controls/DropdownDialog'
import KeyDownHandler from '../key_down_handler'

export default function ChartColorSelectorPanel(){}

ChartColorSelectorPanel.prototype.init = function(closeCallback){
    const self = this;
    this.chartColorSelectorPanel = $("#chartColorSelectorPanel" );
    this.panel = new DropdownDialog({
                                        wrapperClass: "chartColorSelectorPanelWrapper",
                                        dialogDiv: this.chartColorSelectorPanel,
                                        hideButtons: true,
                                        hideOnResize: true,
                                        showEmptyTitleBar : false,
                                        width:'90px',
                                        onClose: function (event) {
                                            /* here we restore old key-down-handler
                                             * and stop propagation of the event in order to avoid restored handler immediate invoking,
                                             * because current key-down event is related only to panel and should be handled only by panel
                                             * */
                                            if (closeCallback) closeCallback();
                                            event.stopPropagation();
                                            KeyDownHandler.restoreOnKeyDownHandler();

                                        }
                                    });



    $(this.chartColorSelectorPanel).find(".imageContainer" ).on("click",function(){self.clickColor(this); self.panel.hide()});
    return this;
};

ChartColorSelectorPanel.prototype.clickColor = function(element){
    $(this.selectedColor).find("div" ).removeClass("selected");
    this.selectedColor = element;
    $(this.selectedColor).find("div" ).addClass("selected");
    this.selectedColorId = $(this.selectedColor ).attr('id');
    if(this.changeCallback)
        this.changeCallback();
};
ChartColorSelectorPanel.prototype.getColorId = function(){
    return this.selectedColorId;
};

ChartColorSelectorPanel.prototype.initAndShow = function ( currentColorId, elementToShowAt, changeCallback) {

    this.chartColorSelectorPanel.find(".selected").removeClass("selected");
    this.selectedColor = $(this.chartColorSelectorPanel).find("#" + currentColorId);
    this.selectedColor.find("div").addClass("selected");
    this.changeCallback = changeCallback;

    this.panel.showAt(elementToShowAt, {my: "left top",
        at: "left bottom",
        collision: "flip"});
    const chartPanel =   $(".chartColorSelectorPanelWrapper");
    chartPanel.width("100px");
    const chartColorSelectorZIndex = $("#createChartLightbox" ).zIndex();
    $(".ui-widget-overlay" ).zIndex(chartColorSelectorZIndex+1);
    chartPanel.zIndex(chartColorSelectorZIndex+2);
    /* we set empty key-down-handler, because:
     * - after the panel is shown, all key-down-events are related only to it and it handles them itself;
     * - we need to save old handler and restore it after the panel is hidden.
     * */
    KeyDownHandler.setOnKeyDownHandler( function () {} );

};



// WEBPACK FOOTER //
// ./web/js/reports/ChartColorSelectorPanel.js